import { render, staticRenderFns } from "./OrderViewAdditionalClaim.vue?vue&type=template&id=67530012&scoped=true&"
import script from "./OrderViewAdditionalClaim.vue?vue&type=script&lang=js&"
export * from "./OrderViewAdditionalClaim.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewAdditionalClaim.vue?vue&type=style&index=0&id=67530012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67530012",
  null
  
)

export default component.exports